<div class="card mt-3">
   <div class="card-body">
      <fieldset>
         <legend>Billing History</legend>

         @if (subscriptionPaymentTransactionsIsLoading() || !accountIsSettled()) {
         <div class="d-flex justify-content-center my-3">
            <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
               <span class="visually-hidden">Loading...</span>
            </div>
         </div>
         } @else if (subscriptionPaymentTransactionsErrorMessage()) {
         <div class="alert alert-danger my-3" role="alert">
            <strong>Unable to load billing history.</strong>
            <div class="small">{{ subscriptionPaymentTransactionsErrorMessage() }}</div>
         </div>
         } @else if (subscriptionPaymentTransactions().length) {
         <app-payment-transactions [subscriptionPaymentTransactions]="subscriptionPaymentTransactions()"
                                   [isRefunding]="refundIsSubmitting()"
                                   (refund)="refundPaymentTransaction($event)"></app-payment-transactions>
         } @else if (isPartnerBilled()) {
         <p class="text-muted mb-0"><em>No transactions on file for {{ billingFrequencyDescription() }} billing frequency.</em></p>
         } @else {
         <p class="text-muted mb-0"><em>No transactions on file.</em></p>
         }

      </fieldset>

      @if (accountIsSettled() && !isPartnerBilled()) {
      <fieldset class="mt-4">
         <legend class="d-flex align-items-center justify-content-between">
            <span>Payment Method</span>
            <button type="button"
                    class="btn btn-sm btn-site-outline-secondary mb-2"
                    (click)="addNewPaymentMethod()">
               Add New Payment Method
            </button>
         </legend>

         @if (subscriptionAuthorizationsIsLoading()) {
         <div class="d-flex justify-content-center my-3">
            <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
               <span class="visually-hidden">Loading...</span>
            </div>
         </div>
         } @else if (subscriptionAuthorizationsErrorMessage()) {
         <div class="alert alert-danger my-3" role="alert">
            <strong>Unable to load billing.</strong>
            <div class="small">{{ subscriptionAuthorizationsErrorMessage() }}</div>
         </div>
         } @else {
         @let subAuths = subscriptionAuthorizations();
         <div id="divActivePayment" class="ms-3 pt-3 mb-3">
            <!-- if multiple subscriptions were supported we would need edit for each subauth (edit would call subscriptionsconroller method  -->
            @for(subAuth of subAuths; track subAuth.id) {
            <div>

               <h5>{{subAuth.subscription.product.displayName}}: {{subAuth.paymentInstrument.info.currencyShortDescription || '$'}}{{subAuth.amount}}</h5>

               <app-payment-instrument-display [paymentInstrument]="subAuth.paymentInstrument"></app-payment-instrument-display>

            </div>
            }
         </div>
         }

      </fieldset>
      }

   </div>
</div>
